import TouchableRippleM from "@common/components/button/TouchableRippleM"
import { theme } from "@common/theme/theme"
import { LinearGradient } from "expo-linear-gradient"
import React from "react"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

/**
 * Round gradient "+" CTA that opens the AI activity generator in student
 * self-create mode. Shared by the todo list screen, the activities catalog
 * and the live-mode todo modal so the button stays visually identical
 * across all three entry points. Pass `style` to tweak spacing per context.
 */
const SelfCreateActivityButton = ({ onPress, style }) => (
    <TouchableRippleM
        onPress={onPress}
        style={{
            height: 50,
            width: 50,
            alignSelf: "center",
            borderRadius: 25,
            overflow: "hidden",
            ...style,
        }}
    >
        <LinearGradient
            colors={[theme.colors.samLight, theme.colors.purple]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 25,
            }}
        >
            <FontAwesome5 name="plus" size={20} color={theme.colors.white} />
        </LinearGradient>
    </TouchableRippleM>
)

export default SelfCreateActivityButton
